module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"validUntil":"Questionario valido fino al:"}}')
  delete Component.options._Ctor
}
